export const ASSIGN_FIRM_TO_USER_MUTATION = `
  mutation AssignFirmToUser($userId: Int!, $firmId: Int!, $companyId: Int!) {
    insert_user_firms_one(
      object: { user_id: $userId, firm_id: $firmId, company_id: $companyId },
      on_conflict: { constraint: user_firms_user_id_firm_id_key, update_columns: [] }
    ) {
      id
      user_id
      firm_id
      company_id
    }
  }
`;

export const DELETE_USER_FIRM_MUTATION = `
  mutation DeleteUserFirm($id: Int!) {
    delete_user_firms_by_pk(id: $id) {
      id
    }
  }
`;
